/**
 * Lithofinder - Client-side interactive stone care advisor
 * Zero API costs for the wizard - all logic runs in the browser
 * Photo recognition delegated to Camera modal (uses Worker API securely)
 */
(function () {
  "use strict";

  var root = document.getElementById("lithofinder-wizard");
  if (!root) return;

  var data = window.LithofinderData;
  if (!data) return;

  var lang = root.dataset.lang || "en";
  var rootUrl = (root.dataset.rootUrl || "/").replace(/\/$/, "");

  // Koopflow (DECK-195, fase 3): /recommend leeft op de worker, niet op de
  // wizard-sectie zelf - hergebruik de camera-sectie's config als die op
  // dezelfde pagina staat (homepage), anders het standaard app-proxy-pad.
  var lfCameraEl = document.getElementById("lf-camera");
  var proxyUrl = (lfCameraEl && lfCameraEl.dataset.proxyUrl) || "/apps/lithofinder";
  var country = (lfCameraEl && lfCameraEl.dataset.country) || root.dataset.country || "NL";

  // Valid surface/subtype combinations
  var VALID_SUBTYPES = {
    "natural-stone": ["marble", "granite", "limestone", "sandstone", "slate", "bluestone", "basalt", "travertine"],
    "ceramics": ["porcelain", "ceramic", "glass-mosaic"],
    "artificial-stone": ["concrete", "quartz-composite", "terrazzo"],
    "cotto-terracotta": ["terracotta", "cotto", "clinker"]
  };

  // Problem icons (inline SVG per category)
  var ico = function(d) { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>'; };
  var problemIcons = {
    "cement-residue":    ico('<rect x="2" y="4" width="9" height="7" rx="1"/><rect x="13" y="4" width="9" height="7" rx="1"/><rect x="6" y="14" width="12" height="7" rx="1"/><line x1="2" y1="12.5" x2="22" y2="12.5" opacity=".4" stroke-dasharray="2 2"/>'),
    "general-cleaning":  ico('<path d="M8 2h8l-1 8H9L8 2z"/><rect x="7" y="10" width="10" height="12" rx="2"/><line x1="12" y1="14" x2="12" y2="18" opacity=".4"/>'),
    "oil-grease":        ico('<path d="M12 2c-2 4-6 7-6 11a6 6 0 0012 0c0-4-4-7-6-11z"/><path d="M10 15a2.5 2.5 0 004 0" opacity=".4"/>'),
    "rust-stains":       ico('<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3" fill="currentColor" opacity=".15"/><path d="M9 9l1.5 1.5M15 15l-1.5-1.5M9 15l1.5-1.5M15 9l-1.5 1.5" opacity=".5"/>'),
    "efflorescence":     ico('<path d="M12 20V10M8 20V14M16 20V14"/><path d="M12 10l-3-4M12 10l3-4"/><path d="M8 14l-2-3M16 14l2-3" opacity=".5"/><line x1="4" y1="20" x2="20" y2="20"/>'),
    "algae-moss":        ico('<path d="M12 22V10"/><path d="M12 10C9 6 4 8 4 12s5 4 8 0"/><path d="M12 14c3-4 8-2 8 2s-5 4-8 0" opacity=".6"/>'),
    "limescale":         ico('<path d="M6 3v4a6 6 0 0012 0V3"/><path d="M12 14v4"/><line x1="10" y1="18" x2="14" y2="18"/><circle cx="7" cy="16" r="1" fill="currentColor" opacity=".3"/><circle cx="17" cy="14" r="1" fill="currentColor" opacity=".3"/>'),
    "wax-residue":       ico('<rect x="4" y="14" width="16" height="7" rx="1"/><path d="M4 14c4-2 6 2 8 0s4-2 8 0"/><path d="M8 10c2-3 4-3 8 0" opacity=".4"/>'),
    "stain-protection":  ico('<path d="M12 2L4 7v6c0 5.5 3.8 10.5 8 11.5 4.2-1 8-6 8-11.5V7L12 2z"/><path d="M9 12l2 2 4-4"/>'),
    "color-enhancement": ico('<circle cx="9" cy="10" r="5"/><circle cx="15" cy="10" r="5"/><circle cx="12" cy="15" r="5"/>'),
    "daily-maintenance": ico('<path d="M12 2v4M12 18v4M2 12h4M18 12h4"/><path d="M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" opacity=".5"/><circle cx="12" cy="12" r="2" fill="currentColor" opacity=".15"/>'),
    "anti-slip":         ico('<path d="M4 20L20 4"/><path d="M8 20L20 8" opacity=".7"/><path d="M12 20L20 12" opacity=".4"/><path d="M4 16L16 4" opacity=".7"/><path d="M4 12L12 4" opacity=".4"/>'),
    "mold-mildew":       ico('<circle cx="8" cy="8" r="3"/><circle cx="16" cy="10" r="2.5"/><circle cx="10" cy="16" r="3.5"/><circle cx="17" cy="17" r="2" opacity=".5"/>'),
    "outdoor-cleaning":  ico('<circle cx="12" cy="12" r="4"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M5.6 18.4l2.8-2.8"/>')
  };

  // ── State ──────────────────────────────────────────────────────
  var currentStep = 1;
  var direction = "forward"; // "forward" | "back"
  var selectedSurface = null;
  var selectedSubtype = null;
  var selectedProblem = null;

  // ── Locale helpers (cached) ────────────────────────────────────
  var locCache = {};
  function loc(selector) {
    if (locCache[selector] !== undefined) return locCache[selector];
    var el = document.querySelector(selector);
    locCache[selector] = el ? el.textContent.trim() : "";
    return locCache[selector];
  }

  function subtypeName(id) { return loc('[data-locale-subtype="' + id + '"]') || id.replace(/-/g, " "); }
  function subtypeDesc(id) { return loc('[data-locale-subtype-desc="' + id + '"]') || ""; }
  function problemName(id) { return loc('[data-locale-problem="' + id + '"]') || id.replace(/-/g, " "); }
  function problemDesc(id) { return loc('[data-locale-problem-desc="' + id + '"]') || ""; }
  function tipText(key) { return loc('[data-locale-tip="' + key + '"]') || key; }
  function propLabel(key) { return loc('[data-locale-prop-' + key + ']') || key; }
  function porosityLabel(level) { return loc('[data-locale-prop-porosity-' + level + ']') || level; }

  // ── HTML escape helper (XSS prevention) ──────────────────────
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }

  // ── Step Navigation ────────────────────────────────────────────
  var isTransitioning = false;
  function goToStep(step, dir) {
    if (isTransitioning) return;
    isTransitioning = true;

    direction = dir || "forward";
    var panels = root.querySelectorAll(".lf__panel");
    var currentPanel = root.querySelector(".lf__panel--active");
    var nextPanel = root.querySelector('[data-panel="' + step + '"]');

    if (currentPanel && currentPanel !== nextPanel) {
      currentPanel.classList.remove("lf__panel--active");
      currentPanel.classList.add("lf__panel--exit");
      var exitDone = false;
      function finishExit() {
        if (exitDone) return;
        exitDone = true;
        currentPanel.classList.remove("lf__panel--exit");
        currentPanel.style.display = "";
        isTransitioning = false;
      }
      currentPanel.addEventListener("animationend", finishExit, { once: true });
      // Safety timeout in case animationend doesn't fire
      setTimeout(finishExit, 400);
    } else {
      isTransitioning = false;
    }

    // Show next panel with appropriate animation direction
    nextPanel.classList.add("lf__panel--active");
    nextPanel.classList.remove("lf__panel--back");
    if (direction === "back") {
      nextPanel.classList.add("lf__panel--back");
    }

    currentStep = step;
    updateBreadcrumb(step);
    updateProgress(step);

    // Scroll into view
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function updateBreadcrumb(step) {
    root.querySelectorAll(".lf__crumb").forEach(function(crumb) {
      var s = parseInt(crumb.dataset.step);
      crumb.classList.remove("lf__crumb--active", "lf__crumb--done");
      crumb.removeAttribute("aria-current");
      if (s === step) {
        crumb.classList.add("lf__crumb--active");
        crumb.setAttribute("aria-current", "step");
      } else if (s < step) {
        crumb.classList.add("lf__crumb--done");
      }
    });
  }

  function updateProgress(step) {
    var fill = root.querySelector(".lf__progress-fill");
    if (fill) fill.style.width = (step / 4 * 100) + "%";
  }

  // ── Step 1: Surface Selection ──────────────────────────────────
  root.querySelectorAll("[data-surface]").forEach(function(btn) {
    btn.addEventListener("click", function() {
      selectedSurface = this.dataset.surface;

      // Visual feedback
      root.querySelectorAll("[data-surface]").forEach(function(b) {
        b.classList.remove("lf__surface-card--selected");
      });
      this.classList.add("lf__surface-card--selected");

      renderSubtypes(selectedSurface);

      // Small delay for visual feedback before transition
      setTimeout(function() { goToStep(2, "forward"); }, 150);
    });
  });

  // ── Step 2: Render Subtypes as Visual Cards ────────────────────
  function renderSubtypeCard(sub) {
    var props = data.stoneProperties && data.stoneProperties[sub.id];
    var desc = subtypeDesc(sub.id);
    var propsHtml = "";

    if (props) {
      var hardnessBar = '<div class="lf__mini-bar"><div class="lf__mini-fill" style="width:' + (props.hardness * 10) + '%"></div></div>';
      var acidClass = props.acidSensitive ? "lf__tag--warn" : "lf__tag--ok";
      var acidText = props.acidSensitive ? ico('<path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><circle cx="12" cy="17" r=".5" fill="currentColor"/>') : ico('<path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/>');

      propsHtml =
        '<div class="lf__card-props">' +
          '<span class="lf__card-prop">' +
            '<span class="lf__card-prop-label">' + propLabel("hardness") + '</span>' +
            '<span class="lf__card-prop-val">' + props.hardness + '/10 ' + hardnessBar + '</span>' +
          '</span>' +
          '<span class="lf__card-prop">' +
            '<span class="lf__card-prop-label">' + propLabel("porosity") + '</span>' +
            '<span class="lf__card-prop-val lf__prop-porosity--' + props.porosity + '">' + porosityLabel(props.porosity) + '</span>' +
          '</span>' +
          '<span class="lf__card-prop ' + acidClass + '">' +
            '<span class="lf__card-acid-icon">' + acidText + '</span>' +
          '</span>' +
        '</div>';
    }

    return '<button class="lf__subtype-card" data-subtype="' + sub.id + '" type="button">' +
      '<div class="lf__subtype-card-body">' +
        '<h4 class="lf__subtype-name">' + subtypeName(sub.id) + '</h4>' +
        (desc ? '<p class="lf__subtype-desc">' + desc + '</p>' : '') +
      '</div>' +
      propsHtml +
    '</button>';
  }

  function renderSubtypes(surfaceId) {
    var container = document.getElementById("lf-subtypes");
    var surface = data.surfaceTypes.find(function(s) { return s.id === surfaceId; });
    if (!surface) return;

    container.innerHTML = surface.subtypes.map(renderSubtypeCard).join("");

    // Bind handlers
    container.querySelectorAll("[data-subtype]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        selectedSubtype = this.dataset.subtype;

        container.querySelectorAll("[data-subtype]").forEach(function(b) {
          b.classList.remove("lf__subtype-card--selected");
        });
        this.classList.add("lf__subtype-card--selected");

        renderProblems(selectedSurface);
        setTimeout(function() { goToStep(3, "forward"); }, 150);
      });
    });
  }

  // ── Stone Info Card (shown in step 3 above problem chips) ──────
  function renderStoneInfo() {
    var infoEl = document.getElementById("lf-stone-info");
    if (!infoEl) return;
    var props = data.stoneProperties && data.stoneProperties[selectedSubtype];
    if (!props) { infoEl.innerHTML = ""; return; }

    var hardnessBar = '<div class="lf__prop-bar"><div class="lf__prop-fill" style="width:' + (props.hardness * 10) + '%"></div></div>';
    var porosityVal = porosityLabel(props.porosity);
    var acidIcon = props.acidSensitive
      ? '<span class="lf__prop-warn">' + ico('<path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><circle cx="12" cy="17" r=".5" fill="currentColor"/>') + '</span>'
      : '<span class="lf__prop-ok">' + ico('<path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/>') + '</span>';

    infoEl.innerHTML =
      '<div class="lf__stone-card">' +
        '<div class="lf__stone-card-row">' +
          '<span class="lf__prop-label">' + propLabel("hardness") + '</span>' +
          '<span class="lf__prop-value">' + props.hardness + '/10 ' + hardnessBar + '</span>' +
        '</div>' +
        '<div class="lf__stone-card-row">' +
          '<span class="lf__prop-label">' + propLabel("porosity") + '</span>' +
          '<span class="lf__prop-value lf__prop-porosity--' + props.porosity + '">' + porosityVal + '</span>' +
        '</div>' +
        '<div class="lf__stone-card-row">' +
          '<span class="lf__prop-label">' + propLabel("acid") + '</span>' +
          '<span class="lf__prop-value">' + acidIcon + ' ' + (props.acidSensitive ? loc("[data-locale-prop-acid-no]") : loc("[data-locale-prop-acid-yes]")) + '</span>' +
        '</div>' +
      '</div>';
  }

  // ── Step 3: Render Problems as Visual Cards ────────────────────
  function renderProblems(surfaceId) {
    var container = document.getElementById("lf-problems");
    var availableProblems = data.surfaceProblems[surfaceId] || [];

    renderStoneInfo();

    container.innerHTML = availableProblems.map(function(probId) {
      var icon = problemIcons[probId] || "";
      var desc = problemDesc(probId);
      return '<button class="lf__problem-card" data-problem="' + probId + '" type="button">' +
        (icon ? '<span class="lf__problem-icon">' + icon + '</span>' : '') +
        '<div class="lf__problem-text">' +
          '<span class="lf__problem-name">' + problemName(probId) + '</span>' +
          (desc ? '<span class="lf__problem-desc">' + desc + '</span>' : '') +
        '</div>' +
      '</button>';
    }).join("");

    container.querySelectorAll("[data-problem]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        selectedProblem = this.dataset.problem;

        container.querySelectorAll("[data-problem]").forEach(function(b) {
          b.classList.remove("lf__problem-card--selected");
        });
        this.classList.add("lf__problem-card--selected");

        renderRecommendation();
        setTimeout(function() { goToStep(4, "forward"); }, 150);
      });
    });
  }

  // ── Step 4: Render Recommendation ────────────────────────────
  //
  // DECK-195 (fase 3): het statische data.recommendations-object (client-
  // side, 176 cellen) was hier de ENIGE bron, inclusief een "geen resultaat,
  // neem contact op"-doodloper. De koopbare kaarten + method/tips komen nu
  // live van GET /api/proxy/recommend (worker, fase 2), dat een eigen
  // fallback-trap heeft (T1 exacte cel -> T2 subtype -> T3 surface -> T4
  // globale noodlijst) - er bestaat daardoor geen "geen aanbeveling"-pad
  // meer; elk bezoek eindigt in koopbare producten. Bij een netwerkfout
  // (T6) valt de catch hieronder terug op het oude client-side pad.
  function renderRecommendation() {
    var container = document.getElementById("lf-results");
    var surfaceName = subtypeName(selectedSubtype);
    var probName = problemName(selectedProblem);

    container.innerHTML =
      '<div class="lf__result">' +
        '<div class="lf__result-header">' +
          '<h2>' + loc("[data-locale-products]") + '</h2>' +
          '<p>' + surfaceName + ' \u2014 ' + probName + '</p>' +
        '</div>' +
        '<div class="lf__products" id="lf-recommend-cards"><p class="lf-cards__loading">' + loc("[data-locale-loading-products]") + '</p></div>' +
        '<div id="lf-recommend-extra"></div>' +
      '</div>';

    var cardsEl = document.getElementById("lf-recommend-cards");
    var extraEl = document.getElementById("lf-recommend-extra");
    var params = "surface=" + encodeURIComponent(selectedSurface)
      + "&subtype=" + encodeURIComponent(selectedSubtype)
      + "&problem=" + encodeURIComponent(selectedProblem)
      + "&country=" + encodeURIComponent(country)
      + "&locale=" + encodeURIComponent(lang);

    fetch(proxyUrl + "/recommend?" + params)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (result) {
        if (!result || !result.products || !result.products.length || !window.LithofinderCards) {
          cardsEl.innerHTML = "";
          return;
        }
        cardsEl.innerHTML = window.LithofinderCards.render(result.products, {
          source: "wizard",
          subtype: selectedSubtype,
          problem: selectedProblem,
          strings: {
            addToCart: loc("[data-locale-add-to-cart]"),
            addRoutineToCart: loc("[data-locale-add-routine]"),
            leadTimeBadge: loc("[data-locale-lead-time]"),
          },
        });

        var methodHtml = result.method
          ? '<div class="lf__method"><h3>' + loc("[data-locale-method]") + '</h3><p>' + esc(result.method) + '</p></div>'
          : '';
        var tipsHtml = result.tips && result.tips.length
          ? '<div class="lf__tips"><h3>' + loc("[data-locale-tips]") + '</h3><ul>' + result.tips.map(function (k) { return '<li>' + tipText(k) + '</li>'; }).join("") + '</ul></div>'
          : '';
        var guidesHtml = '<div class="lf__guides">' +
          '<h3>' + loc("[data-locale-guides]") + '</h3>' +
          '<a href="' + rootUrl + '/pages/stone-' + selectedSubtype + '" class="lf__guide-link">' +
            ico('<circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>') +
            ' ' + loc("[data-locale-learn-stone]") +
          '</a>' +
          '<a href="' + rootUrl + '/pages/problem-' + selectedProblem + '" class="lf__guide-link">' +
            ico('<path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>') +
            ' ' + loc("[data-locale-learn-problem]") +
          '</a>' +
        '</div>';
        var expertHtml = '<div class="lf__expert-cta">' + loc("[data-locale-not-right]") + '</div>';
        extraEl.innerHTML = methodHtml + tipsHtml + guidesHtml + expertHtml;
      })
      .catch(function () {
        var rec = data.recommendations[selectedSurface + "/" + selectedSubtype + "/" + selectedProblem];
        if (!rec) { cardsEl.innerHTML = ""; return; }
        var urlMap = window.LithofinProductUrls || {};
        cardsEl.innerHTML = '<div class="lf__products">' + rec.products.map(function (productName) {
          var article = data.productMap[productName];
          var shopifyId = article && data.productIdMap ? data.productIdMap[article] : null;
          var productUrl = (shopifyId && urlMap[shopifyId]) ? urlMap[shopifyId] : rootUrl + "/collections/all";
          return '<div class="lf__product"><div class="lf__product-info"><h4 class="lf__product-name">' + esc(productName) + '</h4>' +
            '<div class="lf__product-actions"><a href="' + productUrl + '" class="lf__btn lf__btn--primary">' + loc("[data-locale-view-product]") + '</a></div></div></div>';
        }).join("") + '</div>';
        if (rec.method) extraEl.innerHTML = '<div class="lf__method"><h3>' + loc("[data-locale-method]") + '</h3><p>' + esc(rec.method) + '</p></div>';
      });
  }

  // ── Back Buttons ───────────────────────────────────────────────
  root.querySelectorAll("[data-back]").forEach(function(btn) {
    btn.addEventListener("click", function() {
      goToStep(parseInt(this.dataset.back), "back");
    });
  });

  // ── Breadcrumb Click (go back to completed steps) ──────────────
  root.querySelectorAll(".lf__crumb").forEach(function(crumb) {
    crumb.addEventListener("click", function() {
      var step = parseInt(this.dataset.step);
      if (step < currentStep) {
        goToStep(step, "back");
      }
    });
  });

  // ── Restart ────────────────────────────────────────────────────
  var restartBtn = document.getElementById("lf-restart");
  if (restartBtn) {
    restartBtn.addEventListener("click", function() {
      selectedSurface = null;
      selectedSubtype = null;
      selectedProblem = null;

      root.querySelectorAll(".lf__surface-card--selected").forEach(function(c) {
        c.classList.remove("lf__surface-card--selected");
      });

      goToStep(1, "back");
    });
  }

  // ── Photo Upload: Opens Camera Modal ─────────────────────────────
  // Instead of direct Gemini API call, delegate to camera modal (secure Worker API)
  var dropzone = document.getElementById("lf-dropzone");
  if (dropzone) {
    var fileInput = dropzone.querySelector(".lf__dropzone-input");

    // Click handler → open camera modal
    dropzone.addEventListener("click", function(e) {
      if (e.target === fileInput) return; // Let file input work normally
      var cameraOpen = document.getElementById("lf-cam-open");
      if (cameraOpen) {
        cameraOpen.click();
      } else {
        // If camera section not loaded, fall back to file input
        fileInput.click();
      }
    });

    // File input change → open camera modal and pass file
    fileInput.addEventListener("change", function() {
      if (this.files && this.files[0]) {
        // Dispatch file to camera system via custom event
        var cameraRoot = document.getElementById("lf-camera");
        if (cameraRoot) {
          var event = new CustomEvent("lf-camera-file", { detail: { file: this.files[0] } });
          cameraRoot.dispatchEvent(event);
          // Open camera modal
          var cameraOpen = document.getElementById("lf-cam-open");
          if (cameraOpen) cameraOpen.click();
        }
        this.value = "";
      }
    });

    // Drag & drop → same delegation
    ["dragenter", "dragover"].forEach(function(evt) {
      dropzone.addEventListener(evt, function(e) {
        e.preventDefault();
        dropzone.classList.add("lf__dropzone--drag");
      });
    });

    ["dragleave", "drop"].forEach(function(evt) {
      dropzone.addEventListener(evt, function(e) {
        e.preventDefault();
        dropzone.classList.remove("lf__dropzone--drag");
      });
    });

    dropzone.addEventListener("drop", function(e) {
      var files = e.dataTransfer?.files;
      if (files && files[0]) {
        var cameraRoot = document.getElementById("lf-camera");
        if (cameraRoot) {
          var event = new CustomEvent("lf-camera-file", { detail: { file: files[0] } });
          cameraRoot.dispatchEvent(event);
          var cameraOpen = document.getElementById("lf-cam-open");
          if (cameraOpen) cameraOpen.click();
        }
      }
    });
  }

  // ── Listen for camera recognition results → auto-advance wizard ──
  window.addEventListener("lf-camera-result", function(e) {
    var result = e.detail;
    if (!result || !result.surface_id || !result.subtype_id) return;

    // Validate surface/subtype
    if (!VALID_SUBTYPES[result.surface_id]) return;
    if (VALID_SUBTYPES[result.surface_id].indexOf(result.subtype_id) === -1) return;

    selectedSurface = result.surface_id;
    selectedSubtype = result.subtype_id;

    // Mark surface card as selected
    root.querySelectorAll("[data-surface]").forEach(function(b) {
      b.classList.toggle("lf__surface-card--selected", b.dataset.surface === result.surface_id);
    });

    // Render problems and advance to step 3
    renderProblems(selectedSurface);
    setTimeout(function() { goToStep(3, "forward"); }, 300);
  });

  // ── Accuracy Hints (loaded from learning system) ──────────────────
  var accuracyHints = null;
  var hintsLoaded = false;

  function loadAccuracyHints() {
    if (hintsLoaded) return;
    hintsLoaded = true;
    var cam = document.getElementById("lf-camera");
    var proxyUrl = cam ? (cam.dataset.proxyUrl || "/apps/lithofinder") : "/apps/lithofinder";
    fetch(proxyUrl + "/feedback/accuracy-hints")
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { accuracyHints = d || {}; })
      .catch(function () { accuracyHints = {}; });
  }

  // Load hints when wizard becomes visible
  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      loadAccuracyHints();
      observer.disconnect();
    }
  });
  observer.observe(root);

  // Show hint when subtype is selected (augment existing click handler)
  var subtypeContainer = document.getElementById("lf-subtype-grid") || root.querySelector(".lf__subtypes");
  if (subtypeContainer) {
    subtypeContainer.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-subtype]");
      if (!btn || !accuracyHints) return;
      var id = btn.dataset.subtype;
      var hint = accuracyHints[id];
      var hintEl = document.getElementById("lf-accuracy-hint");
      if (!hintEl) {
        hintEl = document.createElement("div");
        hintEl.id = "lf-accuracy-hint";
        hintEl.className = "lf__accuracy-hint";
        subtypeContainer.parentNode.insertBefore(hintEl, subtypeContainer.nextSibling);
      }
      if (hint && hint.confusions && hint.confusions.length > 0) {
        hintEl.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg> ' +
          '<span>' + (loc("[data-locale-accuracy-hint]") || "{a} & {b} look similar - use the {scan} for more precision").replace("{a}", esc(id)).replace("{b}", esc(hint.confusions[0])).replace("{scan}", '<button type="button" class="lf__hint-scan">' + (loc("[data-locale-accuracy-scan]") || "camera scan") + '</button>') + '</span>';
        hintEl.style.display = "flex";
        var scanBtn = hintEl.querySelector(".lf__hint-scan");
        if (scanBtn) {
          scanBtn.addEventListener("click", function () {
            var camOpen = document.getElementById("lf-cam-open");
            if (camOpen) camOpen.click();
          });
        }
      } else {
        hintEl.style.display = "none";
      }
    });
  }

  function esc(s) { return s ? s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : ""; }

})();

